import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useSiteSetting = (key: string, defaultValue = false) => {
  const [value, setValue] = useState(defaultValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      const { data } = await supabase
        .from('site_settings')
        .select('bool_value')
        .eq('key', key)
        .maybeSingle();
      if (!active) return;
      if (data) setValue(data.bool_value);
      setLoading(false);
    };
    load();
    return () => {
      active = false;
    };
  }, [key]);

  return { value, loading, setValue };
};
